import { combineReducers } from "redux";
import {
GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT,
GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK,
GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR,
DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP,

APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,
CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,

} from "./actionTypes";

/********** DATATABLE **********/

const defaultDtState = {
  requests: [],
  requestsError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const Dt = (state = defaultDtState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        requestsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK:
      state = {
        ...state,
        requests: action.payload.response.requests,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR:
      state = {
        ...state,
        requests: [],
        totalCount: 0,
        requestsError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP:
      state = {
        ...state,
        requests: [],
        requestsError: null,
      };
      break
  }
  return state;
}

/********** DATATABLE FILTERS **********/

const defaultDtFiltersState = {
  name: '',
};

const DtFilters = (state = defaultDtFiltersState, action) => {
  switch (action.type) {
    case APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS:
      state = action.payload.filters;
      break
    case CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS:
      state = { ...defaultDtFiltersState };
      break
  }
  return state;
}

export default combineReducers({
  Dt,
  DtFilters,
});